module.exports = __webpack_public_path__ + "static/media/daycash_partnersite_logo.367736d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/daycash_partnersite_logo.png
// module id = 376
// module chunks = 0